
if (!customElements.get('notify-me-klavio')) {
    customElements.define('notify-me-klavio', class NotifyMeKlavyio extends HTMLElement {
      constructor() {
        super();
        this.companyId = this.dataset.companyId
        this.submitbtn = this.querySelector('[data-kalvyio-submit]');
        this.submitbtn.addEventListener('click', this.submitBIS.bind(this))
        //this.closeBtn = this.closest('.drawer__inner').querySelector('.product-modal__close')
      }
  
  
  
      submitBIS(evt) {
        evt.preventDefault()
        const variantId = document.querySelector('.j-selected-variant').value
        const email = this.querySelector('#NotificaitonFormEmail');
        const generalErrorMsg = this.querySelector('.general-error-msg');
        const successMessage = this.querySelector('.success-msg');
        generalErrorMsg.innerHTML = ''
        successMessage.innerHTML = ''
  
        if (!email.validity.valid) {
          
          generalErrorMsg.innerHTML = 'Please enter a valid email address'
          return
        }  
        let payload = {}
        if(email.validity.valid) {
          payload = {
            "data": {
              "type": "back-in-stock-subscription",
              "attributes": {
                "profile": {
                  "data": {
                      "type": "profile",
                      "attributes": {
                          "email": email.value,
                      }
                  }
                },
                "channels": ["EMAIL"],
              },
              "relationships": {
                "variant": {
                  "data": {
                    "type": "catalog-variant",
                    "id": `$shopify:::$default:::${variantId}`
                  }
                }
              }
            }
          }  
        }
  
        var requestOptions = {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "revision":"2024-06-15"
            },
            body: JSON.stringify(payload),
        };
  
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id="+this.companyId ,requestOptions)
        .then(result => {
          if(result.status === 202) {
            successMessage.innerHTML = `👍 Thank you!! We'll email you when we're back in stock!`
            // setTimeout(() => {
            //   this.closeBtn.click()
            // }, 2000);
            this.submitbtn.disabled = true
            this.submitbtn.textContent = 'Signed Up!'
            return
          }
          if(result.status !== 202) {
            generalErrorMsg.innerHTML = 'Please check the  email address is correct'
          }
        })
        .catch(error => {
          console.log('error', error)
        });
  
  
      }
    });
  }
  
  
  
  